module.exports = "<svg version=\"1.1\" id=\"_x34_cdb65be-36e7-4681-b3c7-79f32923185c\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 54.3 50\"><title>play-button</title><path class=\"icon-fill\" d=\"M11.7,44.4V5.8c0-3.1,2.6-5.6,5.8-5.7c1.1,0,2.2,0.3,3.1,0.9l31,19c2.7,1.7,3.5,5.1,1.8,7.8c-0.5,0.7-1.1,1.3-1.8,1.7 l-31,19.5c-2.7,1.7-6.3,0.9-8-1.7C12.1,46.5,11.7,45.5,11.7,44.4z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/play-button.svg
// module id = 562
// module chunks = 1